import { useEffect, useState } from "react";
import { useApiContext } from 'context/ApiContext';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Overview page components
import Header from "layouts/mainAdministration/pages/components/Parks/Header";
import Modify from "layouts/mainAdministration/pages/components/Parks/Modify";

function ParkForm() {
    const { parkPaAdm } = useApiContext();

    const [selectedPark, setSelectedPark] = useState(null);

    useEffect(() => {
        console.log(" parkPaAdm : ", parkPaAdm);
        if (parkPaAdm) {
            setSelectedPark(parkPaAdm);
        }
    }, [parkPaAdm]);

    return (
        <MDBox>
            <Header park={selectedPark} page="ParkAdministration">
                <Modify park={selectedPark} page="ParkAdministration" />
            </Header>
        </MDBox >
    );
}

export default ParkForm;